<template>
  <q-bar style="min-width: 250px;" class="bg-white">
    <div class="text-primary" style="white-space: nowrap">
      Yellow River Sedimentation
    </div>
    <q-space></q-space>
  </q-bar>
  <q-separator></q-separator>
  <supporting-layers
    data="sedimentation"
    defaultLayer="93ef9e5d8b254bad91c43f5272022c32"
  ></supporting-layers>
</template>

<script>
import SupportingLayers from './SupportingLayers.vue';
export default {
  name: 'sedimentation',
  components: { SupportingLayers },
  // mounted() {
  //  this.$store.commit('updateCurrentWebMap', 0);
  // },
  activated() {
    this.$store.commit('updateCurrentWebMap', 'sedimentation');
    console.log(this.currentLayers);
    //change map
  },
  deactivated() {
    this.$store.commit('updateSaveWebmapExtent', 'sedimentation');
  },
  data() {
    return {
      currentLayers: '',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#print-header {
  position: absolute;
  top: 0px;
  height: 30px;
}
#print-footer {
  position: absolute;
  bottom: 0px;
  height: 30px;
}
#print-map {
  position: absolute;
  top: 30px;
  height: 500px;
}
</style>
